import React, { createContext, useEffect, useState } from "react";
import config from "../../config";
import i18n from "../../i18n";

export const LanguageContext = createContext();

export const LangProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let lang = urlParams.get("lang")
      ? urlParams.get("lang")
      : localStorage.getItem("appLang") || i18n.language || "en";
    if (config.supportLanguages.indexOf(lang) === -1) lang = "en";
    localStorage.setItem("appLang", lang);
    urlParams.set("lang", lang);
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}?${urlParams.toString()}`
    );
    if (lang === "ar") document.documentElement.dir = "rtl";
    else document.documentElement.dir = "ltr";
    return lang;
  });

  const changeLanguage = (lang) => {
    i18n
      .changeLanguage(lang)
      .then(() => {
        setCurrentLang(lang);
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
        localStorage.setItem("appLang", lang);
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set("lang", lang);
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname}?${urlParams.toString()}`
        );
      })
      .catch((err) => console.error("Language change failed:", err));
  };

  useEffect(() => {
    // Initialize with the stored language
    i18n.changeLanguage(currentLang);
  }, []); // Run only once on mount

  return (
    <LanguageContext.Provider value={{ currentLang, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LangProvider;
